export default __webpack_public_path__ + "static/media/samake.f366b278.png";